"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowIcon = function ArrowIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      fill = _ref.fill;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L5 5L10 0H0Z",
    fill: fill
  }));
};

ArrowIcon.defaultProps = {
  width: '10',
  height: '5',
  viewBox: '0 0 10 5',
  fill: '#666666'
};
ArrowIcon.propTypes = {
  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,

  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,

  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string,

  /**
   * fill for the arrow
   */
  fill: _propTypes["default"].string
};
var _default = ArrowIcon;
exports["default"] = _default;